import { Grid } from '@mui/material';

interface LabelValueDisplayProps {
    label: string;
    value: string | number | null | undefined;
    defaultValue?: string;
    formatter?: (value: any) => string | number;
}

export default function LabelValueDisplay({
    label,
    value,
    defaultValue = '--',
    formatter
}: LabelValueDisplayProps) {
    const displayValue = value !== null && value !== undefined
        ? (formatter ? formatter(value) : value)
        : defaultValue;

    return (
        <>
            <Grid size={6} style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                <label>{label}</label>
            </Grid>
            <Grid size={6} style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>
                {displayValue}
            </Grid>
        </>
    );
}

